import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { EventEditor } from "@/components/admin/EventEditor";

export const Route = createFileRoute("/admin/event")({
  component: EventPage,
  head: () => ({
    meta: [
      { title: "Events — Admin" },
      { name: "description", content: "Manage all events in the UASA program" },
    ],
  }),
});

function EventPage() {
  return (
    <AdminLayout>
      <EventEditor />
    </AdminLayout>
  );
}
